import { Box, Grid, Typography } from '@material-ui/core'
import React from 'react'
import theme from 'src/theme'
import { numberWithCommas } from 'src/utils'
import { activeIndicatorStyle, deactiveIndicatorStyle } from './Conistance'

function IndicatorsComponent({ detail, i, indicatorData, chartLoading, activeIndicator, setActiveIndicator, classN }) {
  // Helper function to get the correct value based on indicator label
  const getIndicatorValue = (label) => {
    const valueMap = {
      'Total Active Sakhis': indicatorData?.total_active_sakhi,
      'Total Onboarded Sakhis': indicatorData?.total_onboarded,
      'Total Schemes': indicatorData?.scheme_count,
      'Total Transactions': indicatorData?.total_application,
      'Total Inactive Sakhis': indicatorData?.total_inactive_sakhi,
      'Total Earning Sakhis': indicatorData?.total_earning_sakhi,
      'Total Income of Sakhis': indicatorData?.total_income_sakhi,
      'Average Income of Sakhis': indicatorData?.avg_income,
      'Median Income of Sakhis': indicatorData?.median,
      'Total Applications': indicatorData?.total_application,
      'Total Services': indicatorData?.services_count,
      'Total Awareness': indicatorData?.awareness_count,
      'Unique Beneficiaries Reached': indicatorData?.beneficiary_count,
      'Total Villages Reached': indicatorData?.village_count,
      'Total SHGs Covered': indicatorData?.total_shg,
      'Number of Households Mapped': indicatorData?.total_household_mapped,
      'Saving Mapped': indicatorData?.savings_mapped,
      'Loan Mapped': indicatorData?.loan_mapped,
      'Insurance Mapped': indicatorData?.insurance_mapped,
      'Investment Mapped': indicatorData?.investment_mapped,
      'Pension Mapped': indicatorData?.pension_mapped,
      'Households with Low Resilience': indicatorData?.low_score_count,
      'Households with Moderate Resilience': indicatorData?.medium_score_count,
      'Households with High Resilience': indicatorData?.high_score_count,
      'Households with Full Resilience': indicatorData?.full_score_count,
    };
    
    return numberWithCommas(Number(valueMap[label]) || 0);
  };

  // Helper function to get additional label info
  const getAdditionalInfo = (label) => {
    if (label === 'Unique Beneficiaries Reached') {
      return ` (M: ${numberWithCommas(Number(indicatorData?.male_count))}, F:${numberWithCommas(Number(indicatorData?.female_count))}, T:${numberWithCommas(Number(indicatorData?.transgender_count))})`;
    } else if (label === 'Total Schemes') {
      return ` (Scheme: ${numberWithCommas(Number(indicatorData?.scheme))} )`;
    } else if (label === 'Total Services') {
      return ` (Services: ${numberWithCommas(Number(indicatorData?.services))} )`;
    } else if (label === 'Total Awareness') {
      return ` (Awareness: ${numberWithCommas(Number(indicatorData?.awareness))} )`;
    } else if (label === 'Total Onboarded Sakhis') {
      return ` (Exit Sakhi: ${numberWithCommas(Number(indicatorData?.total_removed_sakhi))} )`;
    }
    return '';
  };

  // Check if this indicator should show the rupee symbol
  const showRupeeSymbol = [4, 5, 6].includes(i);

  return (
    <Grid item xs={6} sm={6} md={6} lg={6}
      className={classN ? `py-0.5 px-0.5 transform  translate-y-0 z-0 transition duration-500 delay-${i === 0 ? 100 : i === 1 ? 150 : i === 2 ? 200 : i === 3 ? 300 : i === 4 ? 500 : i === 5 ? 700 : i === 6 ? 1000 : i === 7 ? `[1500ms]` : i === 8 ? `[2000ms]` : i === 9 ? `[2500ms]` : i === 10 ? `[3000ms]` : i === 11 ? `[3500ms]` : i === 12 ? `[4000ms]` : `[5000ms]`}  ease-in-out` : `py-0.5 px-0.5  transform  translate-y-full z-0 transition duration-500 ease-in-out opacity-0 `}
      key={detail?.label}
    >
      {chartLoading ? (
        <Box className="w-full h-28 animate-pulse rounded-lg bg-gray-100 shadow-lg p-2 px-3 flex flex-col justify-between items-start">
          <Box className="w-full flex justify-start items-center space-x-2 animate-pulse">
            <Box className="w-10 h-10 p-1 bg-red-100 rounded-full flex justify-center items-center animate-pulse">
              {detail.icon}
            </Box>
            <Typography
              variant="caption"
              style={{
                color: theme.palette.grey[900],
                fontSize: "16px",
              }}
            >
              {detail.label}
            </Typography>
          </Box>
          <Typography
            varitan="h1"
            style={{ fontSize: "24px", fontWeight: "bold" }}
          ></Typography>
        </Box>
      ) : (
        <Box className={activeIndicator === detail?.label
          ? activeIndicatorStyle : deactiveIndicatorStyle}
          onClick={() => setActiveIndicator(detail?.label)}
        >
          <Box className="w-full flex justify-start items-center space-x-2">
            <Box className="min-w-16 min-h-16 w-16 h-16 p-1 bg-red-100 rounded-full flex justify-center items-center">
              {detail.icon}
            </Box>
            <Box>
              <Typography
                variant="caption"
                style={{
                  color: theme.palette.grey[900],
                  fontSize: "16px",
                }}
              >
                {detail.label}
              </Typography>
              <Typography
                varitan="h1"
                style={{ fontSize: "20px", fontWeight: "bold" }}
              >
                {showRupeeSymbol && <span>&#x20B9;</span>}
                {getIndicatorValue(detail?.label)}
                <br />
                <span className='text-sm font-normal break-normal'>
                  {getAdditionalInfo(detail?.label)}
                </span>
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Grid>
  )
}

export default IndicatorsComponent